"use strict";

var _defineProperty = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var AbstractReportConverter_1 = require("../../conversions/AbstractReportConverter");

var DashboardReportType_1 = require("../DashboardReportType");

var NewSalesDashboardReport_1 = require("../model/NewSalesDashboardReport");

var NewSalesDashboardReportConverter =
/*#__PURE__*/
function (_AbstractReportConver) {
  _inherits(NewSalesDashboardReportConverter, _AbstractReportConver);

  function NewSalesDashboardReportConverter() {
    _classCallCheck(this, NewSalesDashboardReportConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NewSalesDashboardReportConverter).apply(this, arguments));
  }

  _createClass(NewSalesDashboardReportConverter, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new NewSalesDashboardReport_1.NewSalesDashboardReport(source.id, source.root, conversions.asEnum(source.type, DashboardReportType_1.DashboardReportType), source.userCategories, source.completed, source.error, source.filter, this.mapToObj(source.rootMapping, conversions));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        id: source.id,
        root: source.root,
        type: source.type,
        userCategories: source.userCategories,
        completed: source.completed,
        error: source.error,
        filter: source.filter,
        rootMapping: this.mapToDoc(source.rootMapping, conversions)
      };
    }
  }, {
    key: "mapToObj",
    value: function mapToObj(source, conversions) {
      var map = immutable_1.Map();

      if (source) {
        Object.keys(source).forEach(function (key) {
          map = map.set(key, source[key]);
        });
      }

      return map;
    }
  }, {
    key: "mapToDoc",
    value: function mapToDoc(source, conversions) {
      var doc = {};

      if (!source.isEmpty()) {
        source.forEach(function (val, key) {
          doc = Object.assign(doc, _defineProperty({}, key, val));
        });
      }

      return doc;
    }
  }]);

  return NewSalesDashboardReportConverter;
}(AbstractReportConverter_1.AbstractReportConverter);

exports.NewSalesDashboardReportConverter = NewSalesDashboardReportConverter;